/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import styles from './DateInput.module.scss';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment-timezone';

export type DateInputProps = {
  onValueChange: any;
  name?: string;
  maxDate?: any;
  tableEntryArray?: any;
  date?: string;
  setMaxTableRowsCount?: any;
  required?: any;
};

const DateInput = ({ onValueChange, name, maxDate, date, setMaxTableRowsCount, tableEntryArray, required }: DateInputProps) => {
  const [excludeDates, setExcludeDates] = useState([])
  const [isToday, setIsToday] = useState(false)

  useEffect(() => {
    if (tableEntryArray.length) {
      const datesToExclude = tableEntryArray.map((day) => day.date)
      setExcludeDates(datesToExclude)


      setIsToday(moment(tableEntryArray[0].date).endOf('week').format('MMDD') > moment().format('MMDD'))
    }

  }, [tableEntryArray.length])

  useEffect(() => {
    if (isToday) {
      setMaxTableRowsCount(new Date().getDay())
    } else {
      setMaxTableRowsCount('')
    }
  }, [isToday])

  return (
    <div className={styles.DateInput} data-testid="DateInput">
      <label className={styles.DateInputLabel}>Date Worked {required && <span style={{ color: 'red' }}>*</span>}</label>
      <DatePicker
        id='dateWorked'
        name={name}
        selected={date}
        onChange={(date) => onValueChange(date)}
        className={styles.DateInputBox}
        withPortal
        placeholderText="Select Date"
        maxDate={!tableEntryArray[0] ? maxDate : isToday ? moment().toDate() : moment(tableEntryArray[0].date).endOf('week').toDate()}
        minDate={tableEntryArray[0] && moment(tableEntryArray[0].date).startOf('week').toDate()}
        excludeDates={[...excludeDates]}
      // dayClassName={date => {
      //   const selectedDay = tableEntryArray.find((day) => day.date.getDay() === date.getDay())
      //
      //   if (selectedDay) {
      //     return 'disabled-date'
      //   } else {
      //     return undefined
      //   }
      // }}
      />
    </div>
  );
};

export default DateInput;
